import { useRef, useState, useEffect } from "react";
import './CricketStadium.css'

const CricketStadium = () => {
    const fizzyRef = useRef(null);
    const [isFizzyVisible, setIsFizzyVisible] = useState(false);
  
    useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setIsFizzyVisible(true);
            }
          });
        },
        { threshold: 0.5 }
      );
  
      if (fizzyRef.current) {
        observer.observe(fizzyRef.current);
      }
  
      const fizzyRefCurrentValue = fizzyRef.current;
  
      return () => {
        if (fizzyRefCurrentValue) {
          observer.unobserve(fizzyRefCurrentValue);
        }
      };
    }, []);
  
    return (
      <div
        className="heightsizes"
        style={{
          width: "100%",
          height: "auto",
          position: "relative",
          top: "-200px",
          zIndex: 2,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
        }}
      >
        <img
          alt="bottle-background"
          className="desktop"
          src="https://campabeveragesadmin.ril.com/uploads/Scroll_2_Desktop_Bottle_Background_29111779fb.png"
          style={{
            display: "block",
          }}
        />
        <img
          alt="Mobile Background"
          className="mobile"
          src="https://campabeveragesadmin.ril.com/uploads/Scroll_2_Mobile_Bottle_Background_19ab5126d5.png"
          style={{
            display: "none",
          }}
        />
        <img
          alt="Bottle overlay crowned"
          className="desktopcrowd"
          src="https://campabeveragesadmin.ril.com/uploads/Scroll_2_Desktop_Bottle_Overlay_Crowed_113ae41860.png
                "
          style={{
            position: "absolute",
            bottom: "0",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 2,
            display: "block",
          }}
        />
  
        <img
          alt="bottle-overlay"
          className="mobilecrowd"
          src="	https://campabeveragesadmin.ril.com/uploads/Scroll_2_Mobile_Bottle_Overlay_Crowed_5e8de9228f.png" // Replace with your new image URL
          style={{
            position: "absolute",
            bottom: "0",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 2,
            display: "none",
          }}
        />
        <img
          className="bottledisplayed"
          ref={fizzyRef}
          src="https://campabeveragesadmin.ril.com/uploads/Campa_cricket_Bottle_238881cf10.png"
          alt="cricket-bottle"
          style={{
            // position: 'absolute',
            position: "absolute",
            // top: '13%',
            left: "41%",
            // transform: 'translateY(16%)',
            // border: '1px solid',
            width: "19%",
            // cursor: 'pointer',
            zIndex: 1,
            //animation:  'dropFromTop 1.9s ease-out forwards' ,
            animation: isFizzyVisible
              ? "dropFromTop 1.9s ease-out forwards"
              : "none",
            // top: animateBottle ? '13%' : '-100%',
            top: "-100%",
          }}
        />
        <img
          className="needcompress"
          src="https://campabeveragesadmin.ril.com/uploads/Scroll_2_Mobile_GIT_Unit_63178e5680.png"
          alt="scroll"
          style={{
            position: "absolute",
            // transform: 'translateX(-50%)',
            zIndex: 3,
            width: "126px",
            height: "168px",
          }}
        />
  
        <div
          className="fizzycolumn"
          style={{
            position: "absolute",
            zIndex: 4,
          }}
        >
          <h5
            className="fizzy"
            style={{
              color: "#fff",
              fontStyle: "italic",
              fontFamily: "LogikWide",
              textAlign: "right",
              whiteSpace: "wrap",
            }}
          >
            FIZZY LEMONY REHYDRATOR
          </h5>
        </div>
        <div
          className="poweredcolumn"
          style={{
            position: "absolute",
            zIndex: 2,
          }}
        >
          <h5
            className="powered"
            style={{
              color: "#fff",
              fontStyle: "italic",
              fontFamily: "LogikWide",
              // lineHeight: '1.2',
              whiteSpace: "pre-wrap",
            }}
          >
            POWERED WITH ELECTROLYTES
          </h5>
          <button className="more-info-btn">
            MORE INFO
            <img
              src={`${process.env.REACT_APP_BASENAME}/svgs/info.svg`}
              alt="info icon"
              style={{
                width: "24px",
                height: "24px",
              }}
            />
          </button>
          <div className="info-box">
            <p
              style={{
                color: "#fff",
                fontFamily: "InterRegular",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-evenly",
                margin: "0",
                padding: "0",
                textAlign: "left",
              }}
            >
              <img
                alt="info icon"
                src={`${process.env.REACT_APP_BASENAME}/svgs/info.svg`}
                style={{ width: "24px", height: "24px" }}
              />
              Refresh the Josh & bring your
              <br />
              cheering A-game to every match!
              <br />
              The hydrating, refreshing &<br />
              electrolyte-rich drink is the
              <br />
              perfect partner for every game.
            </p>
          </div>
        </div>
      </div>
    );
  };

export default CricketStadium;